module.exports = __webpack_public_path__ + "static/20-geometric-stacked-shapes-d5884e13a3ec714d1d8feadd4ec5ee93.png";